export default __webpack_public_path__ + "static/map-af961fa4e07fb10940c4b1900007d12f.png";